import styled from "styled-components";

export default c => styled(c)`
  .chart-height {
    min-height: 300px;
  }

  .no-data-font-size {
    font-size: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/chart/style.js